<template>
  <div>
    <b-container>
      <b-col sm="12" md="7" lg="5" class="mx-auto">
        <b-card class="card-center my-5">
          <b-card-body>
            <b-card-title class="text-center" style="padding-bottom: 20px">
              <slot name="card-title"></slot>
            </b-card-title>
            <slot name="card-body"></slot>
          </b-card-body>
        </b-card>
      </b-col>
    </b-container>
  </div>
</template>

<script>
  export default {
  };
</script>

<style scoped>

</style>
